/**
 * Device Storage API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface RefurbSplit { 
    batch?: string;
    deviceClass?: RefurbSplit.DeviceClassEnum;
    deviceId?: string;
    movedToProduction?: Array<string>;
    outcome?: RefurbSplit.OutcomeEnum;
    productionStart?: string;
    skippedBecause?: string;
}
export namespace RefurbSplit {
    export const DeviceClassEnum = {
        Collar: 'COLLAR',
        ExternalSensor: 'EXTERNAL_SENSOR',
        Camera: 'CAMERA',
        Tt4Sensor: 'TT4_SENSOR',
        ConfigurationDevice: 'CONFIGURATION_DEVICE',
        DropOff: 'DROP_OFF',
        TrapTransmitter: 'TRAP_TRANSMITTER',
        DataLogger: 'DATA_LOGGER'
    } as const;
    export type DeviceClassEnum = typeof DeviceClassEnum[keyof typeof DeviceClassEnum];
    export const OutcomeEnum = {
        Split: 'SPLIT',
        WouldSplit: 'WOULD_SPLIT',
        Skipped: 'SKIPPED'
    } as const;
    export type OutcomeEnum = typeof OutcomeEnum[keyof typeof OutcomeEnum];
}


export type OutcomeEnum = typeof RefurbSplit.OutcomeEnum[keyof typeof RefurbSplit.OutcomeEnum];
